export const ACTION_CODE = 'PRODUCTION_CATEGORIES' + '_ACTION';
